import { Component, Input } from '@angular/core';
import { AppContentfulCloudinaryImageComponent } from '../contentful-cloudinary-image/contentful-cloudinary-image.component';
import { SanitizeContentPipe } from '../../../pipes/sanitize-content.pipe';
import { Router, RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-contentful-mininavigation-block',
  templateUrl: './contentful-mininavigation-block.component.html',
  styleUrls: ['./contentful-mininavigation-block.component.scss'],
  standalone: true,
  imports: [AppContentfulCloudinaryImageComponent, SanitizeContentPipe, RouterLink, NgClass],
})
export class AppContentfulMiniNavigationBlockComponent {
  @Input() miniNavigation: any;
  currentUrl: string;
  constructor(private router: Router) {
    this.currentUrl = this.router.url.split('#')[0];
  }
}
